import React from 'react';
import PropTypes from 'prop-types';

const FormField = (props) => {
    const {
        label,
        labelClass,
        error
    } = props;
    return (
        <div className='mt-4 mb-4'>
            {
                label ? (
                    <div>
                        <label className={labelClass}>{label}</label>
                    </div>
                ) : null
            }
            
            <div>{props.children}</div>

            {
                error ? (
                    <div className='text-sm mt-1 text-red-700'>
                        {error}
                    </div>
                ) : null
            }
            
        </div>
    )
}

FormField.propTypes = {
    label : PropTypes.string,
    labelClass : PropTypes.string,
    error: PropTypes.string,
};

export default FormField;



